package navigation.home.dashboard

import org.koin.dsl.module

val dashboardUiModule
    get() =
        module {
            factory {
                DashboardScreenModel(
                    authRepository = get(),
                    taskRepository = get(),
                    proposalRepository = get(),
                    itineraryRepository = get(),
                    categoryRepository = get(),
                    profileRepository = get(),
                    updateTaskUseCase = get(),
                    loadingManager = get()
                )
            }
        }